import { computed, ref } from 'vue';
import type { Tourflow } from '@aviata/platform-types';

export function useDirectionState() {
  const townFrom = ref<Tourflow.TownFrom>();
  const countryTo = ref<Tourflow.CountryTo>();
  /**
   * Значение `townsTo`
   * null - не выбран ни один курорт
   * пустой массив([]) - выбраны все города. На бэк отправляет пустой массив, бэк считает это за все города.
   * массив с городами(не пустой массив) - выбраны только определенные города.
   * */
  const townsTo = ref<Tourflow.TownTo[] | null>([]);

  const hasTownFrom = computed(() => !!townFrom.value);
  const hasCountryTo = computed(() => !!countryTo.value);
  const hasTownsTo = computed(() => !!townsTo.value);

  function resetDirectionState() {
    townFrom.value = undefined;
    countryTo.value = undefined;
    townsTo.value = null;
  }

  return {
    townFrom,
    hasTownFrom,

    countryTo,
    hasCountryTo,

    townsTo,
    hasTownsTo,

    resetDirectionState,
  };
}
